/**
 * ki/be kapcsolja az adott mező olvashatóságát, azaz láthatóvá teszi a jelszót
 * @author sarkiroka on 2016.07.04.
 */
export default function (id, show) {
	return function () {
		$('#' + id).attr('type', show ? 'text' : 'password');
	};
};
